module.exports = __webpack_public_path__ + "static/media/ImgKOR2.d6203662.svg";